export const stripePublishableKey = process.env.STRIPE_PUBLISHABLE_KEY;
export const stripeSecretKey = process.env.STRIPE_SECRET_KEY;